module.exports = __webpack_public_path__ + "media/images/icons/us-professor-2c4c0eee43595ab0f62a6d8d0b4fe334.svg";